import galleryImage1 from '../images/gallery/10.jpg';
import galleryImage2 from '../images/gallery/25.JPG';
import galleryImage3 from '../images/gallery/30.jpeg';
import galleryImage4 from '../images/gallery/40.jpg';
import galleryImage5 from '../images/gallery/50.jpeg';
import galleryImage6 from '../images/gallery/60.jpg';
import galleryImage7 from '../images/gallery/70.jpg';
import galleryImage8 from '../images/gallery/75.JPG';
import galleryImage9 from '../images/gallery/80.JPG';
import galleryImage10 from '../images/gallery/85.jpg';
import galleryImage11 from '../images/gallery/100.jpg';
import galleryImage12 from '../images/gallery/105.jpg';
import galleryImage13 from '../images/gallery/110.JPG';
import galleryImage14 from '../images/gallery/120.JPG';
import galleryImage15 from '../images/gallery/125.JPG';
import galleryImage16 from '../images/gallery/130.JPG';
import galleryImage17 from '../images/gallery/140.jpg';
import galleryImage18 from '../images/gallery/145.jpg';
import galleryImage19 from '../images/gallery/150.jpg';
import galleryImage20 from '../images/gallery/155.jpg';
import galleryImage21 from '../images/gallery/160.JPG';
import galleryImage22 from '../images/gallery/165.jpg';
import galleryImage23 from '../images/gallery/170.jpg';
import galleryImage24 from '../images/gallery/175.jpg';
import galleryImage25 from '../images/gallery/176.JPG';
import galleryImage26 from '../images/gallery/180.JPG';
import galleryImage27 from '../images/gallery/185.jpg';
import galleryImage28 from '../images/gallery/190.jpg';
import galleryImage29 from '../images/gallery/195.JPG';
import galleryImage30 from '../images/gallery/200.jpg';
import galleryImage31 from '../images/gallery/210.jpg';
import galleryImage32 from '../images/gallery/235.JPG';
import galleryImage33 from '../images/gallery/300.jpg';

export const galleryImages = [
  {
    id: 1,
    src: galleryImage1,
    filename: '10.jpg',
    alt: 'Villa Mandragora — gallery image 1',
  },
  {
    id: 2,
    src: galleryImage2,
    filename: '25.JPG',
    alt: 'Villa Mandragora — gallery image 2',
  },
  {
    id: 3,
    src: galleryImage3,
    filename: '30.jpeg',
    alt: 'Villa Mandragora — gallery image 3',
  },
  {
    id: 4,
    src: galleryImage4,
    filename: '40.jpg',
    alt: 'Villa Mandragora — gallery image 4',
  },
  {
    id: 5,
    src: galleryImage5,
    filename: '50.jpeg',
    alt: 'Villa Mandragora — gallery image 5',
  },
  {
    id: 6,
    src: galleryImage6,
    filename: '60.jpg',
    alt: 'Villa Mandragora — gallery image 6',
  },
  {
    id: 7,
    src: galleryImage7,
    filename: '70.jpg',
    alt: 'Villa Mandragora — gallery image 7',
  },
  {
    id: 8,
    src: galleryImage8,
    filename: '75.JPG',
    alt: 'Villa Mandragora — gallery image 8',
  },
  {
    id: 9,
    src: galleryImage9,
    filename: '80.JPG',
    alt: 'Villa Mandragora — gallery image 9',
  },
  {
    id: 10,
    src: galleryImage10,
    filename: '85.jpg',
    alt: 'Villa Mandragora — gallery image 10',
  },
  {
    id: 11,
    src: galleryImage11,
    filename: '100.jpg',
    alt: 'Villa Mandragora — gallery image 11',
  },
  {
    id: 12,
    src: galleryImage12,
    filename: '105.jpg',
    alt: 'Villa Mandragora — gallery image 12',
  },
  {
    id: 13,
    src: galleryImage13,
    filename: '110.JPG',
    alt: 'Villa Mandragora — gallery image 13',
  },
  {
    id: 14,
    src: galleryImage14,
    filename: '120.JPG',
    alt: 'Villa Mandragora — gallery image 14',
  },
  {
    id: 15,
    src: galleryImage15,
    filename: '125.JPG',
    alt: 'Villa Mandragora — gallery image 15',
  },
  {
    id: 16,
    src: galleryImage16,
    filename: '130.JPG',
    alt: 'Villa Mandragora — gallery image 16',
  },
  {
    id: 17,
    src: galleryImage17,
    filename: '140.jpg',
    alt: 'Villa Mandragora — gallery image 17',
  },
  {
    id: 18,
    src: galleryImage18,
    filename: '145.jpg',
    alt: 'Villa Mandragora — gallery image 18',
  },
  {
    id: 19,
    src: galleryImage19,
    filename: '150.jpg',
    alt: 'Villa Mandragora — gallery image 19',
  },
  {
    id: 20,
    src: galleryImage20,
    filename: '155.jpg',
    alt: 'Villa Mandragora — gallery image 20',
  },
  {
    id: 21,
    src: galleryImage21,
    filename: '160.JPG',
    alt: 'Villa Mandragora — gallery image 21',
  },
  {
    id: 22,
    src: galleryImage22,
    filename: '165.jpg',
    alt: 'Villa Mandragora — gallery image 22',
  },
  {
    id: 23,
    src: galleryImage23,
    filename: '170.jpg',
    alt: 'Villa Mandragora — gallery image 23',
  },
  {
    id: 24,
    src: galleryImage24,
    filename: '175.jpg',
    alt: 'Villa Mandragora — gallery image 24',
  },
  {
    id: 25,
    src: galleryImage25,
    filename: '176.JPG',
    alt: 'Villa Mandragora — gallery image 25',
  },
  {
    id: 26,
    src: galleryImage26,
    filename: '180.JPG',
    alt: 'Villa Mandragora — gallery image 26',
  },
  {
    id: 27,
    src: galleryImage27,
    filename: '185.jpg',
    alt: 'Villa Mandragora — gallery image 27',
  },
  {
    id: 28,
    src: galleryImage28,
    filename: '190.jpg',
    alt: 'Villa Mandragora — gallery image 28',
  },
  {
    id: 29,
    src: galleryImage29,
    filename: '195.JPG',
    alt: 'Villa Mandragora — gallery image 29',
  },
  {
    id: 30,
    src: galleryImage30,
    filename: '200.jpg',
    alt: 'Villa Mandragora — gallery image 30',
  },
  {
    id: 31,
    src: galleryImage31,
    filename: '210.jpg',
    alt: 'Villa Mandragora — gallery image 31',
  },
  {
    id: 32,
    src: galleryImage32,
    filename: '235.JPG',
    alt: 'Villa Mandragora — gallery image 32',
  },
  {
    id: 33,
    src: galleryImage33,
    filename: '300.jpg',
    alt: 'Villa Mandragora — gallery image 33',
  },
];

export const galleryPreviewImages = galleryImages.slice(0, 9);
